import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from './slices/apiSlice';
import authApiSliceReducer from './slices/authApiSlice';


const store = configureStore({
  reducer: { 
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authApiSliceReducer,
  },
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware().concat
      (apiSlice.middleware),
  devTools: process.env.NODE_ENV !== 'production',
});


export default store;